import styles from './ArrowButton.module.scss';

export const ArrowButton = () => {
	return (
		<button className={styles.ArrowButton__button}>
			<svg
				className={styles.ArrowButton__icon}
				viewBox='0 0 16 16'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M8.5 2.5L14 8L8.5 13.5L7.56 12.56L11.37 8.75H2V7.25H11.37L7.56 3.44L8.5 2.5Z'
					fill='currentColor'
				/>
			</svg>
		</button>
	);
};
